import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import classNames from "classnames";
import { Chip, makeStyles, Typography, RaiseColors } from "client/componentLibrary";
import { ListingStateEnum } from "utils/Enums";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles({
  root: {
    height: "18px",
    borderRadius: "4px"
  },
  label: {
    padding: "2px 4px"
  }
});
var labelColor = {
  predicted: RaiseColors.grape,
  on_market: RaiseColors.onMarket,
  proposals: RaiseColors.warning,
  leased: RaiseColors.alarm,
  dead: RaiseColors.alarm,
  leases: RaiseColors.warning,
  not_available: RaiseColors.gray200
};
var StatusChip = function StatusChip(_ref) {
  var listingState = _ref.listingState,
    customLabel = _ref.customLabel,
    customColor = _ref.customColor,
    customRootClass = _ref.customRootClass;
  var listingStateObj = _valuesInstanceProperty(ListingStateEnum)[listingState];
  var statusLabel = (listingStateObj === null || listingStateObj === void 0 ? void 0 : listingStateObj.label) || customLabel;
  var color = labelColor[listingStateObj === null || listingStateObj === void 0 ? void 0 : listingStateObj.value] || customColor;
  var classes = useStyles();
  return /*#__PURE__*/_jsx(Chip, {
    classes: {
      root: classNames(classes.root, customRootClass),
      label: classes.label
    }
    // inline backgroundColor here to improve performance. Passing color to useStyles was slow to render
    ,
    style: {
      backgroundColor: color
    },
    label: /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_xsmall",
      weight: "semibold",
      color: RaiseColors.white,
      children: statusLabel
    })
  });
};
export default StatusChip;